var jq = jQuery.noConflict();

// hCaptcha
var companyVars = JSON.parse(document.getElementById("companyVars").innerText),
    hCaptchaSiteKey = companyVars.hCaptchaSiteKey;

var captchaIDs = {}; // Holds all hCaptcha elements so that we can use the correct response when there are multiples on a page

/**
 * Renders an hCaptcha widget into every `.h-captcha` element on the page.
 *
 * Named in the `?onload=` parameter of the hCaptcha script loaded centrally by
 * snippets/javascripts.php, so hCaptcha invokes it once its API is ready. Each
 * widget id is stored in `captchaIDs` keyed by its owning form's DOM id, which
 * is how the `.validate-form` submitHandler resolves the right widget when a
 * page carries more than one form. On solve, the token is appended to that form
 * as a hidden `h-captcha-response` input and the form is submitted.
 *
 * @returns {void}
 */
function hCaptchaOnLoad () {
    // Add hcaptcha to all forms on a page
     jq('.h-captcha').each(function () {
        var form = jq(this).closest('form');
        // form is a jQuery object, so form[0].id is required — form.id is undefined
        // and would register every widget on the page under one key.
        window.captchaIDs[form[0].id] = hcaptcha.render(this.id, {
            "sitekey" : window.hCaptchaSiteKey,
            "callback": function (token) {
                jq('<input>', {
                    type: 'hidden',
                    name: 'h-captcha-response',
                    value: token
                }).appendTo(form);
                form.submit();
            }
        });
    }); 
}

jq(document).ready(function() {
    // Checkbox Groups
    var update_sec_checkboxes = function () {
        if (jq("#ir-sec-all").is(":checked")) {
            jq(".ir-sec-sub").prop("checked", true).prop("disabled", true);
        } else {
            jq(".ir-sec-sub").prop("disabled", false).prop("checked", false);
        }
    }
    jq("#ir-sec-all").change(update_sec_checkboxes);
    if (jq("#ir-sec-all").is(":checked")) {
        jq(".ir-sec-sub").prop("checked", true).prop("disabled", true);
    }

    jq('.mobile-nav-trigger').click(function(){
        jq('.main-nav').css('height', 'auto');
    });
    jq('.parallax-window').parallax();
    var menuRight = document.getElementById( 'mobile-nav' ),
    showRight = document.getElementById( 'showRight' ),
    body = document.body;
    
    if (showRight) {
        showRight.onclick = function() {
            jq(this).toggleClass("active");
            jq('body').toggleClass('push-to-left');
            jq('.with-border').toggleClass('push-to-left');
            jq('.navigation-wrapper').toggleClass('push-to-left');
            jq(menuRight).toggleClass("cbp-spmenu-open");
            disableOther( 'showRight' );
        };
    }
    function disableOther( button ) {
        if( button !== 'showRight' ) {
          jq(showRight).toggleClass("disabled");
        }
    }
    
    var contactBanner = jq('.contact-banner.affixed');
    
    if (contactBanner.length) {
        jq(contactBanner).affix({
            offset: { 
                top: jq(".contact-banner").offset().top - 170
            }
        });
    }

    // Basic Form Validation
    var validator = jq(".validate-form");
    validator.each(function () {
        var $form = jq(this);
        var formID = $form.attr('id');
        jq(this).validate({
            rules: {
                password_confirm: {
                    equalTo: "#password",
                    messages: {
                        equalTo: "Passwords must be the same"
                    }
                }
            },
            errorPlacement: function (error, element) {
                error.appendTo(element.parent());
            },
            submitHandler: function (form) {
                if (hcaptcha.getResponse(window.captchaIDs[formID])) {
                    form.submit();
                } else {
                    hcaptcha.reset(window.captchaIDs[formID]);
                    hcaptcha.execute(window.captchaIDs[formID]);
                }
            }
        });
    });

    jq('.toggle-button').click(function() {
        jq(this).toggleClass("open");
    });

    jq('.fancybox').fancybox({
        helpers: {
            overlay: {
                locked: false
            }
        },
        minHeight: '600'
    });

    //Bootrap Select
    jq('.selectpicker').selectpicker({
        iconBase: 'DIN',
        tickIcon: 'no-icon'
    });
    
    //File input
    var fileInput = jq('.file-text input');
    fileInput.change(function(){
        $this = jq(this);
        jq(this).parent('.file-text').children('.text-wrapper').text($this.val());
    });

    //Video Player
    if (Modernizr.touchevents && jq(window).width() < 768 ) {
        jq('body').addClass('touch-device');
        jq(".video-player").each(function(index) {
            var video = jq(this).data('video');
            jq(this).attr('href', video);
        });
        jq('.fancybox,.thickbox').each(function() {
            jq(this).removeClass('thickbox').removeClass('fancybox').attr('target', '_blank');    
        }); 
    } else {
        jq('.video-player').fancybox({
            type: 'iframe',
            scrolling: 'no',
            iframe: { scrolling : 'no' },
            fitToView: true,
            autoSize: true,
            width: 640,
            height: 480,
            beforeShow: function() {
                var frame_width = jq(this.element).data("width"),
                    frame_height = jq(this.element).data("height");
                if (frame_width) {
                    this.width = frame_width;
                }
                if (frame_height) {
                    this.height = frame_height;
                }
            }
        });
    }
    
    //Hide IR Hero Video Button on iOS
    var heroVideo = jq('.page-hero.video');
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (iOS) {
        heroVideo.find('.video-btn').hide();
    }
    
    // Tooltips
    jq('[data-toggle="tooltip"]').tooltip();
 
});

// Equal Heights
jq(window).load(function() {
    checkWidth();
});

// Trivia Collapse
jq(document).click(function (event) {
    var clickover = jq(event.target);
    var $trivia = jq("#trivia-item");
    var _opened = $trivia.hasClass("in");
    if (_opened === true && !clickover.hasClass("tweet")) { 
        console.log(clickover);
        $trivia.collapse('hide');
    }
});

// Blinking effect on menu text in header
// window.setInterval(function(){
//     (function blink() {
//         jq(".blink").fadeOut(1500).fadeIn(1500, blink); 
//     })();
// }, 5000);

function blink() {
    jq(".blink").fadeOut(500).fadeIn(500).fadeOut(500).fadeIn(500); 
}


// Stellar
jq.stellar({
    horizontalOffset: 0,
    verticalOffset: 0,
});

// Change Header on Scroll
jq(function() {
    var header = jq(".big-header");
    jq(window).scroll(function() {
        var scroll = jq(window).scrollTop();

        if (scroll >= 100) {
            header.removeClass('big-header').addClass("small-header");
        } else {
            header.removeClass("small-header").addClass('big-header');
        }
    });
});

jq(function() {
    var header = jq(".big-sub");
    jq(window).scroll(function() {
        var scroll = jq(window).scrollTop();

        if (scroll >= 100) {
            header.removeClass('big-sub').addClass("small-sub");
        } else {
            header.removeClass("small-sub").addClass('big-sub');
        }
    });
});

// SEC Filings Quick Filter
jq('.spr-ir-sec-filters table tr:first-child').prepend(
    jq.makeArray(
        jq('.sb-nav li.active ul li a').map(function(i, a) {
            return '<td class="quick-filter"><a href="' + a.href + '">' + jq(a).text() + '</a></td>';
        })
    ).join("")
);

var pathname = window.location.pathname;
jq('.quick-filter a').each(function(index) {
    var url = jq(this).attr('href').split('/');
    url = url[url.length - 1];
    match_url = document.location.pathname.split('/');
    match_url = match_url[match_url.length - 1];
    if (url == match_url) {
        jq(this).parent().addClass("active");
    }
});

function checkQuoteProperty(value, digits) {
    if (!digits) digits = 2;
    return (value != "N/A") ? parseFloat(value).toFixed(digits) : value;
}
// Quote Box
function populateQuoteBox(quote) {

    if (jq('.ir-quote-box').length > 0) {
        var quoteContainer = jq('.ir-quote-box[data-symbol="' + quote.symbol + '"]');
    } else {
        var quoteContainer = jq('.quote-box[data-symbol="' + quote.symbol + '"]');
        var home_change = true;
    }

    var quote_price = checkQuoteProperty(quote.last),
        quote_change = checkQuoteProperty(quote.change),
        quote_change_pct = checkQuoteProperty(quote.change_pct),
        quote_high = checkQuoteProperty(quote.high),
        quote_low = checkQuoteProperty(quote.low),
        quote_day_low = checkQuoteProperty(quote.day_low),
        quote_day_high = checkQuoteProperty(quote.day_high);

    quoteContainer.find('.time').html('<time />');
    quoteContainer.find('time').attr('datetime', quote.last_trade_time).html(quote.last_trade_time);
    quoteContainer.find('.price .value').html('<sup>$</sup>' + quote_price);
    jq('.header-quote .value').append('<span class="price">$' + quote_price + '</span>');
    quoteContainer.find('.volume .value').html(quote.volume).digits();

    if (quote.market_cap == 'N/A') {
        quoteContainer.find('.market-cap').hide();
    } else {
        quoteContainer.find('.market-cap .value').html('$' + quote.market_cap);
    }

    var change = quote_change.replace(/[+|-]/g, '');

    
    quoteContainer.find('.change .value .number').html('<span class="eqicon-change-02"></span>' + change);
    
    if (quote.change != 'N/A') {
        jq('.header-quote .value').append(' ' + quote.change);
    }
    
    if(quote_change_pct != '0.00' && quote_change_pct != 'N/A' && quote_change_pct != '0' ) {
        quoteContainer.find('.change .value .percent').html('(' + quote_change_pct + '%)');
        jq('.header-quote .value').append(' (' + quote_change_pct + '%)');
    }
    if (home_change) {
        quoteContainer.find('.change .home-change-value').html(change);
    }

    if (quote.change.indexOf('+') > -1 && change !== '0' && change !== '0.00') {
        quoteContainer.find('.change').addClass('up');
    } else if (quote.change.indexOf('-') > -1) {
        quoteContainer.find('.change').addClass('down');
    }
    
    if (quote.low == quote.high) {
        week = quote_low;    
    } else {
        var week = quote_low + ' - ' + quote_high;         
    }
    quoteContainer.find('.week-range .value').html(week);

    if (quote.day_low != 'N/A' && quote.day_high != 'N/A') {
        if (quote.day_low == quote.day_high) {
            var day = quote_day_low;
        } else {
            day = quote_day_low + ' - ' + quote_day_high;
        }
        quoteContainer.find('.day-range .value').html(day);
    } else {
        quoteContainer.find('.day-range .value').html(quote.last)
    }

}

function abbrNum(number, decPlaces) {
    var orig = number;
    var dec = decPlaces;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);

    // Enumerate number abbreviations
    var abbrev = ["K", "M", "B", "T"];

    // Go through the array backwards, so we do the largest first
    for (var i = abbrev.length - 1; i >= 0; i--) {

        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);

        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;

            // Handle special case where we round up to the next abbreviation
            if ((number == 1000) && (i < abbrev.length - 1)) {
                number = 1;
                i++;
            }

            // console.log(number);
            // Add the letter for the abbreviation
            number += abbrev[i];

            // We are done... stop
            break;
        }
    }

    //console.log('abbrNum('+ orig + ', ' + dec + ') = ' + number);
    return number;
}

// Add commas to numbers
jq.fn.digits = function() {
    return this.each(function() {
        jq(this).text(jq(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
    });
};

//Smooth scroll to
function goToByScroll(id) {
    jq('html,body').animate({
        scrollTop: jq(id).offset().top
    }, 'slow');
}
jq('.smooth').click(function() {
    goToByScroll(jq(this).attr('href'));
    return false;
});

//Check Width
jq(window).resize(function() {
    checkWidth();
});

function checkWidth() {
    if (jq(window).width() > 767) {
        jq('.js-same-height, .js-same-height-row').each(function() {
            jq(this).addClass('active');
        });
        sameHeight();
    } else {
        jq('.js-same-height, .js-same-height-row').each(function() {
            jq(this).removeClass('active');
        });
        jq(".js-same-height,.js-same-height-row .js-height").css('min-height', 0);
    }
    if (jq(window).width() < 769) {
        jq('.fancybox').each(function() {
            jq(this).addClass('.fancybox-holder').removeClass('fancybox');
        });
        jq('.thickbox').each(function() {
            jq(this).addClass('.thickbox-holder').removeClass('thickbox');
        });
    } else {
        jq('.fancybox-holder').each(function() {
            jq(this).addClass('.fancybox').removeClass('fancybox-holder');
        });
        jq('.thickbox-holder').each(function() {
            jq(this).addClass('.thickbox').removeClass('thickbox-holder');
        });
    }

}

// Add Background
function add_bg(element) {
    var bg = jq(element).data('bg-image'),
        color = jq(element).data('bg-color'),
        repeat = jq(element).data('bg-repeat');
    if (bg !== undefined) {
        jq(element).css("background-image", "url(" + bg + ")");
    }
    if (color !== undefined) {
        jq(element).css("background-color", color);
    }
    if (repeat !== undefined) {
        jq(element).css('background-repeat', repeat);
    }
}

// Same Height
function sameHeight() {
    jq('#sidebar').css('min-height', 0);
    var $sidebar_min_height = jq('#sidebar + div').outerHeight();
    jq('#sidebar').css('min-height', $sidebar_min_height);
    jq(".js-same-height-row").each(function() {
        var $maxHeight = 0,
            $window_width = jq(window).width();
        jq('.js-same-height', this).css({
            'height': 'auto',
            'min-height': 0
        });
        if ((jq(this).data('cutoff') && jq(this).data('cutoff') >= $window_width) || $window_width < 768) {
            return false;
        }
        jq('.js-same-height', this).each(function() {
            if (jq(this).outerHeight() > $maxHeight) {
                $maxHeight = jq(this).outerHeight();
            }
        }).css('min-height', $maxHeight);
        jq('.js-height', this).css({
            'height': $maxHeight,
            'min-height': 0
        });
    });
}

// Fixes XBRL Filing Close Button click event being unbound by an early call to tb_remove
jq(document).ajaxComplete(function() {
    jq('#TB_closeAjaxWindow #TB_closeWindowButton').on('mousedown', function() {
        tb_remove();
    });
});

// Superscript TM and R
function replaceText(node, expr, replacement) {
	if (node.nodeType == 3 && node.parentNode.tagName != 'SUP') {
		if (node.data.match(expr))
		jq(node).replaceWith(node.data.replace(expr, replacement));
	} else if (node.childNodes) {
		var childNodes = node.childNodes;
		for (var i=0; i < childNodes.length; i++) {
			replaceText(childNodes[i], expr, replacement);
		}
		;
	}
}
replaceText(document, /®/g, '<sup>®</sup>');
replaceText(document, /™/g, '<sup>™</sup>');   